import { storeLogo } from '@/api/cover';

// lodash
import assign from 'lodash/assign';

export default function useCover(menu) {
  const saveLogo = async (menuId, logo) => {
    return await storeLogo(menuId, logo);
  };

  const uploadLogo = async (event) => {
    const logo = event.target.files[0];

    const storedLogo = await saveLogo(menu.value.id, logo);
    if (storedLogo.errors) {
      assign(menu.value, storedLogo);
    } else {
      menu.value = { logo: storedLogo };
    }
  };

  const deleteLogo = () => {
    menu.value = { logo: null };
  };

  return {
    saveLogo,
    uploadLogo,
    deleteLogo,
  };
}
